// @flow

import React from 'react';
import styled from 'styled-components';
import Price from '../../../../../price';
import ProgressRowPriceStyled from './progressRowPrice.styled';
import type { Theme } from '../../../../../../types';

type Props = {
  perMonth: string,
  perMonthAbbrv: string,
};

const InlinePrice = styled<typeof Price, Theme, _>(Price)`
  display: inline-block;
`;

export default ({ perMonth, perMonthAbbrv, ...props }: Props) => (
  <ProgressRowPriceStyled>
    <InlinePrice {...props} />
    {' '}
    {perMonthAbbrv}
  </ProgressRowPriceStyled>
);
